import React, { useState } from 'react';
import dynamic from 'next/dynamic';

const Header = dynamic(() => import('@/components/Header'));
const HeaderValley = dynamic(() => import('@/components/HeaderValley'));
const SubHeader = dynamic(() => import('@/components/SubHeader'));
const WrapperClaim = dynamic(() => import('@/components/WrapperClaim'));
const Title = dynamic(() => import('@/components/Title'));
const SelectorEmpleados = dynamic(() =>
  import('@/components/SelectorEmpleados')
);
const SecurityBenefits = dynamic(() => import('@/components/SecurityBenefits'));
const CircleList = dynamic(() => import('@/components/CircleList'));
const ImageCircleWrapper = dynamic(() =>
  import('@/components/ImageCircleWrapper')
);
const Categories = dynamic(() => import('@/components/Categories')); // TODO: componente + data.json
const IncrementalFigures = dynamic(() =>
  import('@/components/IncrementalFigures')
);
const BannerImgText = dynamic(() => import('@/components/BannerImgText'));
const Necessities = dynamic(() => import('@/components/Necessities'));
const LinkContratos = dynamic(() => import('@/components/LinkContratos'));
const ClickBoxText = dynamic(() => import('@/components/ClickBoxText'));
const ClientTestimonies = dynamic(() =>
  import('@/components/ClientTestimonies')
);
const BannerCta = dynamic(() => import('@/components/BannerCta'));
const VideoBanner = dynamic(() => import('@/components/VideoBanner'));
const FaqsWrapper = dynamic(() => import('@/components/FaqsWrapper'));
const Footer = dynamic(() => import('@/components/Footer'));
const FooterValley = dynamic(() => import('@/components/FooterValley'));
const SectionImageText = dynamic(() => import('@/components/SectionImageText'));
const HorizontalSteps = dynamic(() => import('@/components/HorizontalSteps'));
const BoxesInRow = dynamic(() => import('@/components/BoxesInRow'));
const Flotante = dynamic(() => import('@/components/Flotante'));

export const COMPONENT_POSIBILITIES = {
  MODULO_CABECERAS_FONDOS_EUROPEOS: 'MODULO_CABECERAS_FONDOS_EUROPEOS',
  MODULO_CABECERAS_THE_VALLEY: 'MODULO_CABECERAS_THE_VALLEY',
  MODULO_H2_TITLE: 'MODULO_H2_TITLE',
  MODULO_TITLE_SUBTITLE: 'MODULO_TITLE_SUBTITLE',
  MODULO_SELECTOR_EMPLEADOS: 'MODULO_SELECTOR_EMPLEADOS',
  MODULO_VENTAJAS_SOLUCIONES_DIGITALES: 'MODULO_VENTAJAS_SOLUCIONES_DIGITALES',
  MODULO_CIRCLE_LIST: 'MODULO_CIRCLE_LIST',
  MODULO_IMAGE_CIRCLE: 'MODULO_SOLUCIONES_SOLUCIONES_DIGITALES',
  MODULO_PRINCIPAL_CATEGORIAS: 'MODULO_PRINCIPAL_CATEGORIAS',
  MODULO_RESULTADOS_PORCENTAJES: 'MODULO_RESULTADOS_PORCENTAJES',
  MODULO_NECESIDADES_DIGITALIZACION: 'MODULO_NECESIDADES_DIGITALIZACION',
  MODULO_LINK_CONTRATOS: 'MODULO_LINK_CONTRATOS',
  MODULO_BANNER_CTA_OFERTAS: 'MODULO_BANNER_CTA_OFERTAS',
  MODULO_TESTIMONIOS: 'MODULO_TESTIMONIOS',
  MODULO_BANNER_CTA: 'MODULO_BANNER_CTA',
  MODULO_VIDEO_SOLUCIONES_DIGITALES: 'MODULO_VIDEO_SOLUCIONES_DIGITALES',
  MODULO_BANNER_IMAGEN_TEXTO: 'MODULO_BANNER_IMAGEN_TEXTO',
  MODULO_BANNER_DESTACADO: 'MODULO_BANNER_DESTACADO',
  MODULO_FAQS_PREGUNTAS_FRECUENTES: 'MODULO_FAQS_PREGUNTAS_FRECUENTES',
  MODULO_BANNER_SECTION_IMAGEN_TEXT: 'MODULO_BANNER_SECTION_IMAGEN_TEXT',
  MODULO_BANNER_HORIZONTAL_STEPS: 'MODULO_BANNER_HORIZONTAL_STEPS',
  MODULO_FILA_CAJAS: 'MODULO_FILA_CAJAS',
  MODULO_FOOTER: 'MODULO_FOOTER',
  MODULO_FOOTER_THEVALLEY: 'MODULO_FOOTER_THEVALLEY',
  MODULO_FLOTANTE: 'MODULO_FLOTANTE',
};

const PageLayout = ({ pageInfo }) => {
  const [tipoEmpresa, setTipoEmpresa] = useState('pyme');

  if (!pageInfo || !pageInfo.components) {
    return null;
  }
  return (
    <div className="PageLayoutFondosEuropeos">
      {pageInfo.components.map((item) => {
        switch (item.type) {
          case COMPONENT_POSIBILITIES.MODULO_CABECERAS_FONDOS_EUROPEOS:
            return (
              <>
                <Header {...item.data} />
                {item.data.navigationItems && <SubHeader {...item.data} />}
              </>
            );
          case COMPONENT_POSIBILITIES.MODULO_CABECERAS_THE_VALLEY:
            return <HeaderValley {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_FLOTANTE:
            return <Flotante {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_BANNER_SECTION_IMAGEN_TEXT:
            return <SectionImageText {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_BANNER_HORIZONTAL_STEPS:
            return <HorizontalSteps {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_H2_TITLE:
            return <WrapperClaim {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_TITLE_SUBTITLE:
            return <Title {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_FILA_CAJAS:
            return <BoxesInRow {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_SELECTOR_EMPLEADOS:
            return (
              <SelectorEmpleados
                {...item.data}
                tipoEmpresa={tipoEmpresa}
                setTipoEmpresa={setTipoEmpresa}
              />
            );
          case COMPONENT_POSIBILITIES.MODULO_VENTAJAS_SOLUCIONES_DIGITALES:
            return <SecurityBenefits {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_CIRCLE_LIST:
            return <CircleList {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_IMAGE_CIRCLE:
            if (item.data.tipoEmpresa === tipoEmpresa) {
              return <ImageCircleWrapper {...item.data} />;
            }
            return null;
          case COMPONENT_POSIBILITIES.MODULO_PRINCIPAL_CATEGORIAS:
            if (item.data.tipoEmpresa === tipoEmpresa) {
              return <Categories {...item.data} />;
            }
            return null;
          case COMPONENT_POSIBILITIES.MODULO_RESULTADOS_PORCENTAJES:
            return <IncrementalFigures {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_NECESIDADES_DIGITALIZACION:
            return <Necessities {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_LINK_CONTRATOS:
            if (
              item.data.tipoEmpresa === tipoEmpresa &&
              (item.data.tipoEmpresa === 'empresa' ||
                item.data.tipoEmpresa === 'pyme')
            ) {
              return <LinkContratos {...item.data} />;
            }
            return null;
          case COMPONENT_POSIBILITIES.MODULO_BANNER_CTA_OFERTAS:
            return <ClickBoxText {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_TESTIMONIOS:
            return <ClientTestimonies {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_BANNER_CTA:
            return <BannerCta {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_VIDEO_SOLUCIONES_DIGITALES:
            return <VideoBanner {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_BANNER_IMAGEN_TEXTO:
            return <BannerImgText {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_FAQS_PREGUNTAS_FRECUENTES:
            return <FaqsWrapper {...item.data} />;
          case COMPONENT_POSIBILITIES.MODULO_FOOTER:
            return <Footer />;
          case COMPONENT_POSIBILITIES.MODULO_FOOTER_THEVALLEY:
            return <FooterValley {...item.data} />;
          default:
            return null;
        }
      })}
    </div>
  );
};
export default PageLayout;
